import { gql } from '@apollo/client';

export const GetParkingByIdQuery = gql`
  query GetParkingByIdQuery($id: ID, $alias: String, $now: DateTime) {
    parkings(
      where: { OR: [{ id: { equals: $id } }, { alias: { equals: $alias } }] }
    ) {
      id
      name
      lat
      lng
      full_address
      layoutType
      networkingType
      capacity
      gatesCount
      occupied
      type
      devices(orderBy: { order: asc }) {
        mqttId
        gatesCount
        order
        gates(orderBy: { order: asc }) {
          id
          alias
          order
          capacity
          status
          description
          sessions(where: { endedAt: { equals: null } }) {
            id
            user {
              id
            }
            gate {
              id
              alias
              description
            }
            startedAt
            endedAt
            createdAt
          }
          bookings(where: { endsAt: { gte: $now } }) {
            id
            user {
              id
            }
            startsAt
            endsAt
            createdAt
          }
        }
      }
      bookingLink
      links {
        id
        label
        url
      }
      photo {
        altText
        image {
          publicUrl
        }
        altText
      }

      campaigns {
        id
        startsAt
        endsAt
      }
      parkingQuests(where: { quest: { isActive: { equals: true } } }) {
        quest {
          id
          title
          description
          reward
        }
      }
      subscriptionPlans {
        id
        name
        price
        interval
        currency
        description {
          document
        }
      }
      isUnavailable
      requiresApproval
      requiresIdVerification
      legalAge
      consentPolicies {
        id
        title
      }
      organization {
        id
      }
      organizationName
      referenceParking {
        id
        name
        legalAge
        consentPolicies {
          id
          title
        }
        organization {
          id
        }
        organizationName
      }
      status
      isInUnlockRadius @client
      isSelected @client

      referencedBy {
        id
        devices(orderBy: { order: asc }) {
          mqttId
          gatesCount
          order
          gates(orderBy: { order: asc }) {
            id
            alias
            order
            capacity
            status
            description
            sessions(where: { endedAt: { equals: null } }) {
              id
              user {
                id
              }
              gate {
                id
                alias
                description
              }
              startedAt
              endedAt
              createdAt
            }
            bookings(where: { endsAt: { gte: $now } }) {
              id
              user {
                id
              }
              startsAt
              endsAt
              createdAt
            }
          }
        }
      }
    }
  }
`;
